/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/Onboarding/TxCardFields/Options",
  isInvalid,
  onChange
  
}) {
let dataTxCardFieldOptionsCsvIsValidData = fromData.useDataIsValid({ viewPath,
context: 'data',
path: 'tx_card_field_options_csv',
validate: fromHelpers.validate,
required: true,
})
let dataTxCardFieldOptionsCsvChangeData = fromData.useDataChange({ viewPath,
context: 'data',
path: 'tx_card_field_options_csv',
})
let dataTxCardFieldOptionsCsvNameValueData = fromData.useDataValue({ viewPath,
context: 'data',
path: 'tx_card_field_options_csv.name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 type="file"
 label="IC1-vaxiom.tx_card_field_options.csv"
 marginLeft={dtSpaceXs}
 data="data.tx_card_field_options_csv"
 required={true}
 validate="helpers.js validate"
 invalid={!dataTxCardFieldOptionsCsvIsValidData}
 onChange={dataTxCardFieldOptionsCsvChangeData}
 data="data.tx_card_field_options_csv.name"
 value={dataTxCardFieldOptionsCsvNameValueData}
/>
{children}
</React.Fragment>)
}